import React from "react";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`aboutUs.${key}`);
  const aboutUsText = [
    "With many years of experience and strength in the industry, 911 Casino is committed to providing the safest, reliable, and credible online gaming space.",
    "Sports betting devotes professional manpower and resources to provide complete events, innovative and rich game play for players who love sports.",
    "Live broadcast has professionally trained croupiers from international casinos to play a variety of casino games. All bets are based on croupier actions instead of dead computer probability results. The high-tech web broadcast technology gives players the excitement of experiencing the casino in person.",
    "Experience all kinds of lottery games produce game results based on official results, allowing players to enjoy the most just entertainment in a lively and vivid betting interface.",
    "Video games use the fairest chance of random number generation, allowing players to enjoy diverse entertainment games with peace of mind.",
    "We are committed to providing the most professional products and the most enthusiastic services, so that players can enjoy the most immediate and exciting casino atmosphere of the casino.",
    "In terms of network information security, a network security maintenance center was established to use plural algorithms to encrypt data, so that there is no loophole in the transmission of information between the player and the game, in order to protect all the player's account data and the correct game structure.",
    "And in the spirit of service-oriented, 24 hours a day, to solve players' intractable problems with websites and games, so that every player feels at home and feels the supreme sense of honor of visiting the casino.",
    "Thanks to members for their support, we will hold discounts and promotions from time to time to provide players with more feedback and surprises.",
  ];
  return (
    <section className="w-full mt-[10px] rounded-[5] px-[10px] py-[16px] bg-base-light-white dark:bg-base-light-dark relative mb-[15px] flex flex-col items-center gap-[15px] font-medium">
      <h1 className="my-2 !mt-2 text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold">
        {i18n("About Us")}
      </h1>
      <div className="text-base-deep-dark w-full dark:text-base-light-white">
        <div className="p-8 font-normal">
          {aboutUsText.map((text, index) => (
            <div key={index} className="mb-6 flex flex-col">
              {i18n(text)}
            </div>
          ))}
          　
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
